import React from 'react';
import Select from 'react-select';
import { Container, Label, Feedback } from './styles';

function SelectOne({ options, change, placeholder, searchable, label, value, isDisabled = false, status }) {
  const customStyles = {
    input: (provided, state) => ({
      height: 45,
    }),
    menu: (provided, state) => ({
      ...provided,
      zIndex: 9999,
    }),
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    control: (provided, state) => ({
      ...provided,
      borderColor: status?.status === 'danger' ? '#dc3545' : provided.borderColor,
      '&:hover': {
        borderColor: status?.status === 'danger' ? '#dc3545' : provided.borderColor,
      },
    }),
  };

  return (
    <Container>
      <Label status={status?.status}>{label}</Label>
      <Select
        value={value}
        options={options}
        onChange={(item) => change(item)}
        isSearchable={searchable}
        styles={customStyles}
        placeholder={placeholder}
        menuPortalTarget={document.body}
        isDisabled={isDisabled}
      />
      {status?.status === 'danger' && status?.feedback && (
        <Feedback>{status.feedback}</Feedback>
      )}
    </Container>
  );
}

export default SelectOne;
